import { render } from "./X2102.vue?vue&type=template&id=270022ff"
import script from "./X2102.vue?vue&type=script&lang=js"
export * from "./X2102.vue?vue&type=script&lang=js"

import "./X2102.vue?vue&type=style&index=0&id=270022ff&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__